// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__vKjho","form":"styles_form__3VNV0"};